import { getThorViewEventProps, thorPushEvent } from './common/thor';

export function domReady() {
    let errorCode = '500';
    if (MA.Context.endpoint === 'None') {
        errorCode = '404';
    }
    thorPushEvent('page_view', {
        ...getThorViewEventProps('error', `error_${errorCode}`),
        av_error_code: errorCode,
    });
}
